module.exports = __webpack_public_path__ + "static/media/slide_one.87de38e2.jpg";